// extracted by mini-css-extract-plugin
export default {"greenText":"Timelapse_greenText__sxe2k","yellowText":"Timelapse_yellowText__tNAZE","redText":"Timelapse_redText__GBksP"};